import { useQuery } from "react-query";
import { http } from "shared/util/http";
import { ChequeDTO } from "types/dto/ChequeDTO";

export const useGetProximoChequeDisponivel = (contaBancariaId: number) => {
  return useQuery<ChequeDTO>({
    queryKey: ["proximo-cheque-disponivel", contaBancariaId],
    queryFn: async () => {
      const response = await http.get<ChequeDTO>(
        `/api/cheque/proximo-disponivel?contaBancariaId=${contaBancariaId}`
      );
      return response.data;
    },
    enabled: !!contaBancariaId,
  });
};
